// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"34":"2f8c5aa3","212":"d0c77e1a","631":"83faa816"}[chunkId] + ".css";
};